// extracted by mini-css-extract-plugin
module.exports = {"doctor-card":"doctors-cards_doctor-card__LxVma","wrapper":"doctors-cards_wrapper___lLTC","card-single":"doctors-cards_card-single__jdkyp"};